import { useRef, useCallback } from 'react'

export const useWakeLock = () => {
    const wakelockRef = useRef( null )
    const fallbackVideoRef = useRef( null )

    const requestWakeLock = useCallback( async () => {
        // 1. Native API Attempt
        if ( 'wakeLock' in navigator ) {
            try {
                wakelockRef.current = await navigator.wakeLock.request( 'screen' )
                wakelockRef.current.addEventListener( 'release', () => {
                    wakelockRef.current = null
                } )
                return true
            } catch ( err ) {
                console.warn( 'Native wake lock failed, trying fallback:', err.message )
            }
        }

        // 2. Video Fallback
        if ( fallbackVideoRef.current ) return true

        const video = document.createElement( 'video' )
        video.setAttribute( 'playsinline', '' )
        video.muted = true
        video.loop = true
        video.style.cssText = "position:fixed; opacity:0; width:1px; height:1px; z-index:-1;"

        const blob = new Blob( [
            new Uint8Array( [0, 0, 0, 24, 102, 116, 121, 112, 109, 112, 52, 50, 0, 0, 0, 0, 109, 112, 52, 49] )
        ], { type: 'video/mp4' } )

        video.src = URL.createObjectURL( blob )
        document.body.appendChild( video )
        fallbackVideoRef.current = video

        try {
            await video.play()
            return true
        } catch ( err ) {
            console.error( 'Wake lock fallback failed:', err )
            return false
        }
    }, [] )

    const releaseWakeLock = useCallback( async () => {
        if ( wakelockRef.current ) {
            await wakelockRef.current.release()
            wakelockRef.current = null
        }
        if ( fallbackVideoRef.current ) {
            fallbackVideoRef.current.pause()
            fallbackVideoRef.current.src = ''
            fallbackVideoRef.current.remove()
            fallbackVideoRef.current = null
        }
    }, [] )

    return { requestWakeLock, releaseWakeLock }
}